import { assignmentStatus } from "../utils/enums";

export interface ILinkedAssignmentSummary {
  id: string;
  status: string;
  applicationType: string;
  documentType: string;
}

export type LinkedCompensationMessageVariant = "warning" | "info" | "success";

export interface ILinkedCompensationMessage {
  text: string;
  variant: LinkedCompensationMessageVariant;
}

export function getChildCompensationMessage(
  parentStatus: string | undefined,
  childStatus: string | undefined
): ILinkedCompensationMessage | null {
  if (!parentStatus || !childStatus) {
    return null;
  }

  if (
    parentStatus === assignmentStatus.Realized &&
    childStatus === assignmentStatus.Accepted
  ) {
    return {
      text: "Wyjście zostało już rozliczone. Rozlicz to zlecenie odpracowania, aby przywrócić godziny do puli.",
      variant: "warning",
    };
  }

  if (
    parentStatus === assignmentStatus.Accepted &&
    childStatus === assignmentStatus.Accepted
  ) {
    return {
      text: "To zlecenie służy do odpracowania wyjścia z tego samego dnia. Najpierw rozlicz wyjście, potem odpracowanie.",
      variant: "info",
    };
  }

  if (
    parentStatus === assignmentStatus.Realized &&
    childStatus === assignmentStatus.Realized
  ) {
    return {
      text: "Wyjście i odpracowanie zostały rozliczone.",
      variant: "success",
    };
  }

  if (
    parentStatus === assignmentStatus.Accepted &&
    childStatus === assignmentStatus.Realized
  ) {
    return {
      text: "Odpracowanie rozliczone, ale wniosek o wyjście jeszcze nie — rozlicz wyjście, aby domknąć proces.",
      variant: "warning",
    };
  }

  return null;
}
